import { patchProfile } from '../api/profileApi';
import {
  profileVehiclesToWire,
  validateProfileVehicles,
  type ProfileVehicle,
} from './profileVehicles';
import {
  clearStoredProfileVehicles,
  getStoredProfileVehicles,
} from './profileVehiclesStorage';

/**
 * If the API has no cars yet but this browser still has a legacy local cache,
 * push that list once via PATCH /profile and clear local storage.
 * Only for roles that use vehicles (bookers) — never migrate onto owner profiles.
 */
export async function migrateLegacyLocalProfileVehicles(
  apiVehicles: ProfileVehicle[],
  loginId?: string | null,
  options?: { enabled?: boolean },
): Promise<ProfileVehicle[] | null> {
  if (options?.enabled === false) {
    return null;
  }
  if (apiVehicles.length > 0) {
    clearStoredProfileVehicles(loginId);
    return null;
  }
  const local = getStoredProfileVehicles(loginId);
  if (local.length === 0) {
    return null;
  }
  if (validateProfileVehicles(local) !== null) {
    clearStoredProfileVehicles(loginId);
    return null;
  }
  await patchProfile({ vehicles: profileVehiclesToWire(local) });
  clearStoredProfileVehicles(loginId);
  return local;
}
